export default __webpack_public_path__ + "static/media/greyLock.90309ad6.svg";